// Generated by `php artisan app:generate-api-routes` from the backend's {language} routes. Do not edit.
export const apiRoutes = {
  'attribution.store': { method: 'post', uri: 'attribution' },
  'authentication.send': { method: 'post', uri: 'authentication/send' },
  'authentication.verify': { method: 'post', uri: 'authentication/verify' },
  'backoffice.breed-ai-visibility-observations.index': { method: 'get', uri: 'backoffice/breed-ai-visibility-observations' },
  'backoffice.breed-ai-visibility-observations.store': { method: 'post', uri: 'backoffice/breed-ai-visibility-observations' },
  'backoffice.breeds.content.update': { method: 'put', uri: 'backoffice/breeds/{breed}/content' },
  'backoffice.contracts.show': { method: 'get', uri: 'backoffice/contracts/{contract}' },
  'backoffice.flow-reviews.store': { method: 'post', uri: 'backoffice/flow-reviews' },
  'backoffice.flow-reviews.uploads.store': { method: 'post', uri: 'backoffice/flow-reviews/uploads' },
  'backoffice.imports.show': { method: 'get', uri: 'backoffice/imports/{automaticImport}' },
  'backoffice.listings.import': { method: 'post', uri: 'backoffice/listings/import' },
  'backoffice.payments.show': { method: 'get', uri: 'backoffice/payments/{payment}' },
  'blog.features': { method: 'get', uri: 'blog/features' },
  'breed-advisor.descriptions': { method: 'post', uri: 'breed-advisor/sessions/{session}/descriptions' },
  'breed-advisor.progress': { method: 'put', uri: 'breed-advisor/sessions/{session}/progress' },
  'breed-advisor.refine': { method: 'post', uri: 'breed-advisor/sessions/{session}/refine' },
  'breed-advisor.shares.show': { method: 'get', uri: 'breed-advisor/shares/{share}' },
  'breed-advisor.shares.store': { method: 'post', uri: 'breed-advisor/sessions/{session}/shares' },
  'breed-advisor.show': { method: 'get', uri: 'breed-advisor/sessions/{session}' },
  'breed-advisor.store': { method: 'post', uri: 'breed-advisor/sessions' },
  'breed-matches.show': { method: 'get', uri: 'breed-matches/{breed_match}' },
  'breeder-pets.destroy': { method: 'delete', uri: 'me/breeder/{breeder}/breeder-pets/{breeder_pet}' },
  'breeder-pets.store': { method: 'post', uri: 'me/breeder/{breeder}/breeder-pets' },
  'breeder-pets.update': { method: 'patch', uri: 'me/breeder/{breeder}/breeder-pets/{breeder_pet}' },
  'breeder-posts.destroy': { method: 'delete', uri: 'me/breeder/{breeder}/breeder-posts/{breeder_post}' },
  'breeder-posts.store': { method: 'post', uri: 'me/breeder/{breeder}/breeder-posts' },
  'breeder-posts.update': { method: 'patch', uri: 'me/breeder/{breeder}/breeder-posts/{breeder_post}' },
  'breeders.breeds.destroy': { method: 'delete', uri: 'me/breeder/{breeder}/breeds/{breed}' },
  'breeders.breeds.store': { method: 'post', uri: 'me/breeder/{breeder}/breeds' },
  'breeders.index': { method: 'get', uri: 'breeders' },
  'breeders.litters.index': { method: 'get', uri: 'me/breeder/litters' },
  'breeders.litters.update': { method: 'patch', uri: 'me/breeder/litters/{listing}' },
  'breeders.photos': { method: 'get', uri: 'breeders/{breeder}/photos' },
  'breeders.show': { method: 'get', uri: 'breeders/{breeder}' },
  'breeders.store': { method: 'post', uri: 'me/breeder' },
  'breeders.subscribers.destroy': { method: 'delete', uri: 'me/breeder/{breeder}/subscribers' },
  'breeders.subscribers.store': { method: 'post', uri: 'me/breeder/{breeder}/subscribers' },
  'breeders.update': { method: 'patch', uri: 'me/breeder/{breeder}' },
  'breeds.average-prices': { method: 'get', uri: 'breeds/average-prices' },
  'breeds.compare.show': { method: 'get', uri: 'breeds/{breed}/compare/{comparable}' },
  'breeds.index': { method: 'get', uri: 'breeds' },
  'breeds.listing-cities': { method: 'get', uri: 'breeds/{breed}/listing-cities' },
  'breeds.market-stats': { method: 'get', uri: 'breeds/{breed}/market-stats' },
  'breeds.recommended': { method: 'get', uri: 'breeds/recommended' },
  'breeds.show': { method: 'get', uri: 'breeds/{breed}' },
  'contracts.complete-signature': { method: 'post', uri: 'me/contracts/{contract}/complete-signature' },
  'contracts.destroy': { method: 'delete', uri: 'me/contracts/{contract}' },
  'contracts.show': { method: 'get', uri: 'me/contracts/{contract}' },
  'contracts.start-signature': { method: 'post', uri: 'me/contracts/{contract}/start-signature' },
  'contracts.update': { method: 'patch', uri: 'me/contracts/{contract}' },
  'conversations.authenticate': { method: 'get', uri: 'me/conversations/authenticate' },
  'conversations.block': { method: 'post', uri: 'me/conversations/{conversation}/block' },
  'conversations.buyer-checklist.show': { method: 'get', uri: 'me/conversations/{conversation}/buyer-checklist' },
  'conversations.buyer-checklist.update': { method: 'patch', uri: 'me/conversations/{conversation}/buyer-checklist/{item}' },
  'conversations.get-contact-info': { method: 'get', uri: 'me/listings/{listing}/conversations/contact-info' },
  'conversations.get-unread-count': { method: 'get', uri: 'me/conversations/unread-count' },
  'conversations.index': { method: 'get', uri: 'me/conversations' },
  'conversations.messages.index': { method: 'get', uri: 'me/conversations/{conversation}/messages' },
  'conversations.messages.store': { method: 'post', uri: 'me/conversations/{conversation}/messages' },
  'conversations.read': { method: 'post', uri: 'me/conversations/{conversation}/read' },
  'conversations.show': { method: 'get', uri: 'me/conversations/{conversation}' },
  'conversations.show-breeder': { method: 'get', uri: 'me/breeders/{breeder}/conversation' },
  'conversations.store-breeder': { method: 'post', uri: 'me/breeders/{breeder}/conversations' },
  'conversations.store-listing': { method: 'post', uri: 'me/listings/{listing}/conversations' },
  'conversations.typing': { method: 'post', uri: 'me/conversations/{conversation}/typing' },
  'conversations.unblock': { method: 'delete', uri: 'me/conversations/{conversation}/block' },
  'dog-licence.answers.store': { method: 'post', uri: 'dog-licence/modules/{module}/answers' },
  'dog-licence.attempts.claim': { method: 'post', uri: 'me/dog-licence/attempts' },
  'global-search': { method: 'get', uri: 'global-search' },
  'insurance-calls.get-available-dates': { method: 'get', uri: 'insurance-calls/available-dates' },
  'insurance-calls.get-time-slots': { method: 'get', uri: 'insurance-calls/time-slots' },
  'insurance-calls.store': { method: 'post', uri: 'insurance-calls' },
  'issues.report': { method: 'post', uri: 'issues/report' },
  'likes.check': { method: 'post', uri: 'me/likes/check' },
  'likes.toggle': { method: 'post', uri: 'me/likes' },
  'listings.boosted': { method: 'get', uri: 'listings/boosted' },
  'listings.by-user': { method: 'get', uri: 'backoffice/listings/by-user' },
  'listings.claim': { method: 'post', uri: 'me/listings/{listing}/claim' },
  'listings.destroy': { method: 'delete', uri: 'me/listings/{listing}' },
  'listings.edit': { method: 'get', uri: 'me/listings/{listing}' },
  'listings.index': { method: 'get', uri: 'listings' },
  'listings.instagram-boosted': { method: 'get', uri: 'backoffice/listings/instagram-boosted' },
  'listings.monitor': { method: 'get', uri: 'me/listings/{listing}/monitor' },
  'listings.search-by-slug': { method: 'get', uri: 'listings/search-by-slug' },
  'listings.show': { method: 'get', uri: 'listings/{listing}' },
  'listings.similar': { method: 'get', uri: 'listings/{listing}/similar' },
  'listings.store': { method: 'post', uri: 'me/listings' },
  'listings.update': { method: 'patch', uri: 'me/listings/{listing}' },
  'listings.validate': { method: 'post', uri: 'me/listings/{listing}/validate' },
  'litter-insurances.store': { method: 'post', uri: 'me/listings/{listing}/litter-insurance' },
  'litter-insurances.submittable': { method: 'get', uri: 'backoffice/litter-insurances/submittable' },
  'litter-insurances.submitted': { method: 'patch', uri: 'backoffice/litter-insurances/{litter_insurance}/submitted' },
  'litter-insurances.update': { method: 'patch', uri: 'me/litter-insurances/{litter_insurance}' },
  'marketing.unsubscribe': { method: 'get', uri: 'marketing/unsubscribe/{user}' },
  'marketing.unsubscribe.short': { method: 'get', uri: 'u/{user}/{signature}' },
  'me.complete-identity-verification': { method: 'post', uri: 'me/complete-identity-verification' },
  'me.destroy': { method: 'delete', uri: 'me' },
  'me.dog-licence': { method: 'get', uri: 'me/dog-licence' },
  'me.dog-licence.answers.store': { method: 'post', uri: 'me/dog-licence/modules/{module}/answers' },
  'me.likes': { method: 'get', uri: 'me/likes' },
  'me.listings': { method: 'get', uri: 'me/listings' },
  'me.payments': { method: 'get', uri: 'me/payments' },
  'me.pet-purchases': { method: 'get', uri: 'me/pet-purchases' },
  'me.pets': { method: 'get', uri: 'me/pets' },
  'me.searches': { method: 'get', uri: 'me/searches' },
  'me.show': { method: 'get', uri: 'me' },
  'me.start-identity-verification': { method: 'post', uri: 'me/start-identity-verification' },
  'me.update-address': { method: 'patch', uri: 'me/address' },
  'me.update-buyer-profile': { method: 'patch', uri: 'me/buyer-profile' },
  'me.update-contact-details': { method: 'patch', uri: 'me/contact-details' },
  'media-assets.complete-upload': { method: 'post', uri: 'me/media-assets/{media_asset}/complete-upload' },
  'media-assets.destroy': { method: 'delete', uri: 'me/media-assets/{media_asset}' },
  'media-assets.increment-stats': { method: 'post', uri: 'media-assets/stats' },
  'media-assets.store': { method: 'post', uri: 'me/media-assets' },
  'media-assets.update': { method: 'patch', uri: 'me/media-assets/{media_asset}' },
  'orders.checkout': { method: 'post', uri: 'orders/{order}/checkout' },
  'orders.create-payment': { method: 'post', uri: 'orders/{order}/payments' },
  'orders.payments.show': { method: 'get', uri: 'orders/{order}/payments/{payment}' },
  'orders.show': { method: 'get', uri: 'orders/{order}' },
  'orders.store': { method: 'post', uri: 'orders' },
  'orders.update-item-quantity': { method: 'patch', uri: 'orders/{order}/item-quantity' },
  'payments.products': { method: 'get', uri: 'payments/products' },
  'payments.show': { method: 'get', uri: 'me/payments/{payment}' },
  'payments.store': { method: 'post', uri: 'me/payments' },
  'payments.validate-coupon': { method: 'post', uri: 'me/coupons' },
  'pet-insurances.calculate-price': { method: 'post', uri: 'pet-insurances/calculate-price' },
  'pet-insurances.calculate-price-from-listing': { method: 'post', uri: 'pet-insurances/calculate-price/{listing}' },
  'pet-insurances.health-declaration': { method: 'post', uri: 'pet-insurances/health-declaration' },
  'pet-insurances.store': { method: 'post', uri: 'pet-insurances/subscribe' },
  'pet-insurances.validate-health-declaration': { method: 'post', uri: 'pet-insurances/health-declaration/validate' },
  'pet-purchases.confirm-delivery': { method: 'post', uri: 'me/pet-purchases/{pet_purchase}/confirm-delivery' },
  'pet-purchases.destroy': { method: 'delete', uri: 'me/pet-purchases/{pet_purchase}' },
  'pet-purchases.show': { method: 'get', uri: 'me/pet-purchases/{pet_purchase}' },
  'pet-purchases.store': { method: 'post', uri: 'me/pets/{pet}/pet-purchases' },
  'pet-purchases.update': { method: 'patch', uri: 'me/pet-purchases/{pet_purchase}' },
  'pet-purchases.update-booked-insurance-call': { method: 'patch', uri: 'me/pet-purchases/{pet_purchase}/booked-insurance-call' },
  'pets.destroy': { method: 'delete', uri: 'me/pets/{pet}' },
  'pets.restore': { method: 'post', uri: 'me/pets/{pet}/restore' },
  'pets.store': { method: 'post', uri: 'me/listings/{listing}/pets' },
  'pets.update': { method: 'patch', uri: 'me/pets/{pet}' },
  'pets.update-status': { method: 'patch', uri: 'me/pets/{pet}/status' },
  'posts.index': { method: 'get', uri: 'posts' },
  'posts.show': { method: 'get', uri: 'posts/{post}' },
  'product-categories.index': { method: 'get', uri: 'product-categories' },
  'product-categories.show': { method: 'get', uri: 'product-categories/{product_category}' },
  'product-feedback.store': { method: 'post', uri: 'product-feedback' },
  'products.index': { method: 'get', uri: 'products' },
  'products.show': { method: 'get', uri: 'products/{product}' },
  'push-tokens.store': { method: 'post', uri: 'me/push-tokens' },
  'search-matches.destroy': { method: 'delete', uri: 'me/searches/{search}/search-matches/{search_match}' },
  'search-matches.seen': { method: 'patch', uri: 'me/searches/{search}/search-matches/{search_match}' },
  'searches.destroy': { method: 'delete', uri: 'me/searches/{search}' },
  'searches.show': { method: 'get', uri: 'me/searches/{search}' },
  'searches.store': { method: 'post', uri: 'me/searches' },
  'searches.update': { method: 'patch', uri: 'me/searches/{search}' },
  'shop.feeds.google-merchant': { method: 'get', uri: 'shop/feeds/google-merchant.xml' },
  'shop.feeds.pricerunner': { method: 'get', uri: 'shop/feeds/pricerunner.xml' },
  'shop.settings': { method: 'get', uri: 'shop/settings' },
  'sitemap.get-data': { method: 'get', uri: 'sitemap-data' },
  'stripe-connect.generate-onboarding-link': { method: 'get', uri: 'me/stripe-connect' },
  'tags.index': { method: 'get', uri: 'tags' },
  'tags.show': { method: 'get', uri: 'tags/{tag}' },
} as const;
